import { render, staticRenderFns } from "./IconsModal.vue?vue&type=template&id=2562d7c4&"
import script from "./IconsModal.vue?vue&type=script&lang=js&"
export * from "./IconsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports